import React, { useMemo } from 'react';

import { SingleQuestionController, OpenEndedAnswerType } from '@sm/question-widgets/respondent-survey';
import { ExternalQuestion } from '@sm/question-definitions';
import { ScrollAnchor } from '~app/components/Survey/OneQuestionAtATime';
import groupQuestionsWithLayoutConfig from './utils';
import { QuestionRowLayout } from '../QuestionRowLayout';

// TODO: Add to `@sm/question-widgets/respondent-survey` types
type AnswerObject = {
  [key: string]: OpenEndedAnswerType;
};

export type Props = {
  questions: ExternalQuestion[];
  answers: AnswerObject;
};

function QuestionList({ questions }: Props): React.ReactElement {
  const groups = useMemo(() => groupQuestionsWithLayoutConfig(questions), [questions]);
  return (
    <>
      {groups.map(group => (
        <QuestionRowLayout key={`group_${group.map(g => g.id).concat('-')}`}>
          {group.map(question => (
            <ScrollAnchor key={question.id}>
              {/* TODO: `nextQuestion` requires implementation */}
              <SingleQuestionController {...{ question }} />
            </ScrollAnchor>
          ))}
        </QuestionRowLayout>
      ))}
    </>
  );
}

export default QuestionList;
